import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n/index';
import { HelmetProvider } from 'react-helmet-async';

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

const rootElement = document.getElementById('root');
const hasPrerenderedMarkup = !!(rootElement && rootElement.hasChildNodes());
const onRecoverableError = (error, errorInfo) => {
  const message = error?.message || String(error || '');
  if (!message) {
    return;
  }

  const detail = {
    event: 'react_recoverable_error',
    message,
    component_stack: errorInfo?.componentStack || '',
    path: window.location?.pathname || '',
  };

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(detail);
  }

  // Keep console visibility in QA/Lighthouse runs.
  console.warn('Recoverable React error', detail);
};

if (rootElement) {
  if (hasPrerenderedMarkup) {
    hydrateRoot(rootElement, app, { onRecoverableError });
  } else {
    createRoot(rootElement).render(app);
  }
}

reportWebVitals((metric) => {
  if (typeof window === 'undefined' || !metric) {
    return;
  }

  const detail = {
    event: 'web_vitals',
    metric_name: metric.name,
    metric_value: metric.value,
    metric_delta: metric.delta,
    metric_rating: metric.rating,
    metric_id: metric.id,
    path: window.location?.pathname || '',
  };

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(detail);
  }

  window.dispatchEvent(new CustomEvent('randostat:analytics', { detail }));
});
